/* ═══════════════════════════════════════════
   STRAW HAT SHOP — SHOPIFY THEME JS
   Cards are now rendered by Liquid from real Shopify
   products. This file styles and filters them.
   products2.json is no longer used.
   ═══════════════════════════════════════════ */

/* ── CURSOR ── */
const cur = document.getElementById('cur');
const ring = document.getElementById('ring');
if (cur && ring) {
  let mx = 0, my = 0, rx = 0, ry = 0;
  document.addEventListener('mousemove', e => {
    mx = e.clientX; my = e.clientY;
    cur.style.left = mx + 'px';
    cur.style.top  = my + 'px';
  });
  (function animateRing() {
    rx += (mx - rx) * .12;
    ry += (my - ry) * .12;
    ring.style.left = rx + 'px';
    ring.style.top  = ry + 'px';
    requestAnimationFrame(animateRing);
  })();
  document.querySelectorAll('a, button, .pill, .lang, .pc, nav, .nav-cta').forEach(el => {
    el.addEventListener('mouseenter', () => { cur.classList.add('hov'); ring.classList.add('hov'); });
    el.addEventListener('mouseleave', () => { cur.classList.remove('hov'); ring.classList.remove('hov'); });
  });
}

/* ── NAV SCROLL ── */
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 50);
  });
}

/* ── SCROLL REVEAL ── */
const revealObserver = new IntersectionObserver(entries => {
  entries.forEach((e, i) => {
    if (e.isIntersecting) {
      setTimeout(() => e.target.classList.add('visible'), i * 60);
      revealObserver.unobserve(e.target);
    }
  });
}, { threshold: 0.08 });

/* ── COLORS PER SET ──
   Add a line when a new set launches. Anything missing falls back
   to a neutral scheme, so a new product never renders broken.      */
const SET_COLORS = {
  'op22': { bg:['#0E0A14','#12080E','#0A0610'], accent:'#9B6BC9', accent2:'#5A2D8B' },
  'op21': { bg:['#0A0E14','#08101A','#060A12'], accent:'#4C86C9', accent2:'#1A4A8B' },
  'op20': { bg:['#140E0A','#1A0E06','#100A04'], accent:'#C98A4C', accent2:'#8B5A1A' },
  'op19': { bg:['#0A140E','#06100A','#040C08'], accent:'#4CC98A', accent2:'#1A8B5A' },
  'op18': { bg:['#140A14','#100610','#0C040C'], accent:'#C94CA8', accent2:'#8B1A6B' },
  'op17': { bg:['#0E1014','#0A0C10','#08090C'], accent:'#8AA8C9', accent2:'#4A6B8B' },
  'op16': { bg:['#0E0A14','#1A0E08','#0A0E1A'], accent:'#C9A84C', accent2:'#8B4513' },
  'op15': { bg:['#0A1014','#0A0E08','#0E120A'], accent:'#5B8A3C', accent2:'#2D5A1B' },
  'op14': { bg:['#080E14','#080A12','#060810'], accent:'#3A6B8A', accent2:'#1A3B5A' },
  'op13': { bg:['#140808','#1A0808','#100606'], accent:'#CC2936', accent2:'#8B1A1A' },
  'op12': { bg:['#0A0A14','#08080E','#060612'], accent:'#4A4AFF', accent2:'#1A1A8B' },
  'op11': { bg:['#0E0E08','#12100A','#0A0E06'], accent:'#8B8B3C', accent2:'#5A5A1A' },
  'op10': { bg:['#140A08','#1A0E0A','#100806'], accent:'#CC7A2E', accent2:'#8B4A1A' },
  'op09': { bg:['#080E14','#060A10','#04080C'], accent:'#2E6B8B', accent2:'#1A3B5A' },
  'op08': { bg:['#14080E','#10060A','#0C0408'], accent:'#8B3C6B', accent2:'#5A1A3B' },
  'op07': { bg:['#0A140E','#081008','#060C06'], accent:'#3C8B5A', accent2:'#1A5A2D' },
  'op06': { bg:['#14140A','#101008','#0C0C06'], accent:'#8B8B2E', accent2:'#5A5A1A' },
  'op05': { bg:['#080814','#060610','#04040C'], accent:'#3C3C8B', accent2:'#1A1A5A' },
  'op04': { bg:['#14080A','#100608','#0C0406'], accent:'#8B2E3C', accent2:'#5A1A1A' },
  'op03': { bg:['#0E140A','#0A1008','#080C06'], accent:'#5A8B3C', accent2:'#2D5A1A' },
  'op02': { bg:['#140E08','#100A06','#0C0804'], accent:'#8B5A2E', accent2:'#5A2D1A' },
  'op01': { bg:['#08140E','#06100A','#040C08'], accent:'#2E8B5A', accent2:'#1A5A2D' },
  'eb06': { bg:['#120A12','#0E060E','#0A040A'], accent:'#B85AB8', accent2:'#7A2D7A' },
  'eb05': { bg:['#0A1212','#060E0E','#040A0A'], accent:'#4CB8B8', accent2:'#1A7A7A' },
  'eb04': { bg:['#12120A','#0E0E06','#0A0A04'], accent:'#B8B84C', accent2:'#7A7A1A' },
  'eb03': { bg:['#120A0A','#0E0606','#0A0404'], accent:'#B85A5A', accent2:'#7A2D2D' },
  'eb02': { bg:['#0A0A12','#06060E','#04040A'], accent:'#5A5AB8', accent2:'#2D2D7A' },
  'eb01': { bg:['#0A120A','#060E06','#040A04'], accent:'#5AB85A', accent2:'#2D7A2D' }
};
const FALLBACK = { bg:['#0A0A0A','#111111','#0A0A0A'], accent:'#8A8A8A', accent2:'#555555' };

/* ── PAINT CARDS ──
   Liquid renders the markup; this applies the per-set palette.   */
function paintCards() {
  document.querySelectorAll('.pc').forEach(card => {
    const key = card.dataset.set || '';
    const c = SET_COLORS[key] || FALLBACK;
    card.style.setProperty('--bg0', c.bg[0]);
    card.style.setProperty('--bg1', c.bg[1]);
    card.style.setProperty('--bg2', c.bg[2]);
    card.style.setProperty('--acc', c.accent);
    card.style.setProperty('--acc2', c.accent2);
  });
}

/* ── FILTER ── */
let activeFilter = 'all';
let activeLang = 'en';

function applyFilter() {
  const grid = document.getElementById('pgrid-' + activeLang);
  if (!grid) return;
  grid.querySelectorAll('.pc').forEach(card => {
    const avail = card.dataset.avail === 'true';
    let show = true;
    if (activeFilter === 'avail') show = avail;
    if (activeFilter === 'sold')  show = !avail;
    card.style.display = show ? '' : 'none';
  });
}

function filterSet(btn, type) {
  activeFilter = type;
  document.querySelectorAll('.pill').forEach(p => p.classList.remove('active'));
  if (btn) btn.classList.add('active');
  applyFilter();
}

function switchLang(btn, lang) {
  activeLang = lang;
  document.querySelectorAll('.lang').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');
  document.querySelectorAll('.pgrid').forEach(g => {
    g.style.display = (g.id === 'pgrid-' + lang) ? '' : 'none';
  });
  applyFilter();
}

/* ── INIT ── */
function init() {
  paintCards();
  applyFilter();
  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

window.filterSet = filterSet;
window.applyFilter = applyFilter;
window.switchLang = switchLang;